import { ModelBase } from 'store/model-base';

export class CmsCustomerEligibility extends ModelBase {
    public static storeName: string = 'cmsCustomerEligibility';

    public customerEligibilityCodes: CmsCustomerEligibilityCodes[];
    public lineTypeTooltip: DescriptiveModalData;
    public customerEligibilityDescription: customerEligibilityDescription;
}
